export default "__VITE_ASSET__DJjQks5K__"